export const Suraj_Singh = require("../assets/Suraj_Singh.jpg"); 
export const Photo = require("../assets/photo.jpg");